import { getMinutes } from "@/helper";
import { httpClient } from "@/services";
import app from "@/main";

export default {
	state: {
		dateList: null,
		planerWorkOrder: null,
		tasks: null,
		newOrderCount: null,
		timeLineTotal: '',
		newWorkOrderFilter: null,
		newWorkOrderList: null,
	},
	mutations: {
		updatePlanerTasks(state, { dateList, tasks, newOrder }) {
			state.dateList = dateList;
			state.tasks = tasks;
			state.newOrderCount = newOrder;
		},
		updateDecrementCount(state) {
			state.newOrderCount--;
		},
		updateDrag(state, { to, row }) {
			state.tasks[to.keyTask][to.keyItem][to.keyBody].time = row.time;
			state.tasks[to.keyTask][to.keyItem][to.keyBody].info = row.info;
		},
		updatePlanerTasksSave(state, { from, to }) {
			/* eslint-disable-next-line */
			const { id: elemFromId, position, dayOff: isDayOffFrom, ...elemFrom } = state.tasks[from.keyTask][from.keyItem][from.keyBody];
			const { id, dayOff } = state.tasks[to.keyTask][to.keyItem][to.keyBody];

			state.tasks[from.keyTask][from.keyItem][from.keyBody] = { id: elemFromId, dayOff: isDayOffFrom };
			app.$nextTick(() => {
				state.tasks[to.keyTask][to.keyItem][to.keyBody] = { id, position: to.position, dayOff, ...elemFrom };
			});
		},
		updateWidthSave(state, { from, to }) {
			/* eslint-disable-next-line */
			const { id: elemFromId, position, w, dayOff: isDayOffFrom, ...elemFrom } = state.tasks[from.keyTask][from.keyItem][from.keyBody];
			const { id, dayOff } = state.tasks[to.keyTask][to.keyItem][to.keyBody];

			state.tasks[from.keyTask][from.keyItem][from.keyBody] = { id: elemFromId, dayOff: isDayOffFrom };
			state.tasks[to.keyTask][to.keyItem][to.keyBody] = { id, position: to.position, w: to.width, dayOff, ...elemFrom };
		},
		updateTimeLineTotal(state, { keyBody, position, isLeft }) {
			const minutes = getMinutes(position, isLeft);
			let hours = null;
			if (position === 4 && !isLeft) {
				hours = keyBody === 19 ? 7 : keyBody + 1;
			} else {
				hours = keyBody;
			}

			state.timeLineTotal = hours + minutes;
		},
		updateNewWorkOrder(state, { filter, list }) {
			state.newWorkOrderFilter = filter;
			state.newWorkOrderList = list;
		},
		updatePlanerWorkOrder(state, payload) {
			state.planerWorkOrder = payload;
		},
		updateNewWorkOrderEdit(state, { row, id }) {
			const idx = state.newWorkOrderList.findIndex(item => item.id === id);
			state.newWorkOrderList.splice(idx, 1, row);
		}
	},
	actions: {
		async onDrag({ commit }, values) {
			try {
				const { data } = await httpClient.post('/planner/drag-and-drop', values);
				if (data && data.status) {
					commit('updateDrag', { to: values.to, row: data.row });
				}
			} catch (e) {
				console.error(e);
			}
		},
		onClearPlanerData({ commit }) {
			commit('updatePlanerTasks', { dateList: [], tasks: null });
		},
		onDecrementCount({ commit }) {
			commit('updateDecrementCount');
		},
		async getPlanerTasks({ commit }) {
			try {
				const { data } = await httpClient.get('/planner');
				if (data && !data.status) {
					commit('updatePlanerTasks', data);
				}
			} catch (e) {
				console.error(e);
			}
		},
		async getChangePlanerTasks({ commit }, values) {
			try {
				const { data } = await httpClient.post('/planner/list', values);
				if (data && !data.status) {
					commit('updatePlanerTasks', data);
				}
			} catch (e) {
				console.error(e);
			}
		},
		async getLightOrder({ commit }) {
			try {
				const { data } = await httpClient.get(`/light-order/create`);
				commit('updatePlanerWorkOrder', data);
			} catch (e) {
				console.error(e);
			}
		},
		async onLightOrderSave({ dispatch }, values) {
			try {
				const { data } = await httpClient.post(`/light-order`, values);
				if (data) {
					// await dispatch('getPlanerTasks');
					dispatch('setAlert', { type: "success", message: "Created select item" });
					return data;
				}
			} catch (e) {
				console.error(e);
			}
		},
		async onLightOrderEdit({ dispatch }, values) {
			const { id, ...obj } = values;
			try {
				const { data } = await httpClient.put(`/light-order/${ id }`, obj);
				if (data) {
					// await dispatch('getPlanerTasks');
					dispatch('setAlert', { type: "success", message: "Edit select item" });
					return data;
				}
			} catch (e) {
				console.error(e);
			}
		},
		async onDayOffCreate() {
			try {
				const { data } = await httpClient.get('/day-off/create');
				if (data && !data.status) {
					return data;
				}
			} catch (e) {
				console.error(e);
			}
		},
		async onDayOffFilter(context, values) {
			try {
				const { data } = await httpClient.post('/day-off/create', values);
				if (data && !data.status) {
					return data;
				}
			} catch (e) {
				console.error(e);
			}
		},
		async onDayOff(context, values) {
			try {
				const { data } = await httpClient.post('/day-off', values);
				if (data) {
					// await dispatch('getPlanerTasks');
					return data;
				}
			} catch (e) {
				console.error(e);
			}
		},
		async getDayOffEdit(context, id) {
			try {
				const { data } = await httpClient.post(`/day-off/${ id }/edit`);
				if (data) return data;
			} catch (e) {
				console.error(e);
			}
		},
		async onDayOffEdit({ dispatch }, values) {
			const { id, ...obj } = values;
			try {
				const { data } = await httpClient.put(`/day-off/${ id }`, obj);
				if (data) {
					dispatch('setAlert', { type: "success", message: "Edit day off" });
					return data;
				}
			} catch (e) {
				console.error(e);
			}
		},
		async onRemoveDayOff({ dispatch }, id) {
			try {
				const { data } = await httpClient.delete(`/day-off/${ id }`);
				if (data && data.status) {
					dispatch('setAlert', { type: "success", message: "Remove item day off" });
					return data;
				}
			} catch (e) {
				console.error(e);
			}
		},
		async onRemovePlanerWorkOrder({ dispatch }, id) {
			try {
				const { data } = await httpClient.delete(`/light-order/${ id }`);
				if (data && data.status) {
					dispatch('setAlert', { type: "success", message: "Remove item work order" });
					return data;
				}
			} catch (e) {
				console.error(e);
			}
		},
		async getPlanerWorkOrder({ commit }, id) {
			try {
				const { data } = await httpClient.get(`/planner/${ id }/edit`);
				commit('updatePlanerWorkOrder', data);
			} catch (e) {
				console.error(e);
			}
		},
		async getLightWorkOrder({ commit }, id) {
			try {
				const { data } = await httpClient.get(`/light-order/${ id }/edit`);
				commit('updatePlanerWorkOrder', data);
			} catch (e) {
				console.error(e);
			}
		},
		async onNewWorkOrder({ commit }) {
			try {
				const { data } = await httpClient.get('/planner/create');
				if (data) {
					commit('updateNewWorkOrder', data);
				}
			} catch (e) {
				console.error(e);
			}
		},
		async onCreateClient({ dispatch }, values) {
			try {
				const { data } = await httpClient.post('light-order/create/client', values);
				if (data && data.status) {
					dispatch('setAlert', { type: "success", message: "Created select item" });
					return data.client;
				}
			} catch (e) {
				console.error(e);
			}
		},
		async onPlaner({ commit, dispatch }, values) {
			const { id, ...obj } = values;
			try {
				const { data } = await httpClient.put(`/planner/${ id }`, obj);

				if (data) {
					if (!data.status) {
						return data;
					}
					commit('updateNewWorkOrderEdit', { row: data.row, id });
					// await dispatch('getPlanerTasks');
					await dispatch('onNewWorkOrder');
					return data;
				}
			} catch (e) {
				console.error(e);
			}
		},
		async onNewWorkOrderList({ commit }, values) {
			try {
				const { data } = await httpClient.post('/planner/create/list', values);
				if (data) {
					commit('updateNewWorkOrder', data);
				}
			} catch (e) {
				console.error(e);
			}
		},
		onPlanerTasksSave({ commit, dispatch }, values) {
			commit('updatePlanerTasksSave', values);
			dispatch('onDrag', values);
		},
		onWidthSave({ commit, dispatch }, values) {
			commit('updateWidthSave', values);
			dispatch('onDrag', values);
		},
		onTimeLineTotal({ commit }, values) {
			commit('updateTimeLineTotal', values);
		}
	},
	getters: {
		dateList: s => s.dateList,
		planerWorkOrder: s => s.planerWorkOrder,
		newOrderCount: s => s.newOrderCount,
		tasks: s => s.tasks,
		newWorkOrderFilter: s => s.newWorkOrderFilter,
		newWorkOrderList: s => s.newWorkOrderList,
		timeLineTotal: s => s.timeLineTotal,
	}
};
